<template>
  <main>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="page-heading">
            <h2><span>Xalor</span> Partnerships</h2>
            <p>Xalor is proud to partner with Vixel Studio and Mikes Maps.</p>
          </div>
        </div>
      </div>
      <div class="main-content-box">
        <div class="top-page-divider">
          <h3 class="page-title center">Discord Servers</h3>
        </div>

        <div class="partnerships--grid">
          <div class="partnerships--col card">
            <img src="@/assets/img/vixel.png" class="discord-server-icon">
            <h5>Vixel Studio</h5>
            <a href="https://discord.gg/58Q28EEC84" target="_target" class="btn large discord"><i
                class="fab fa-discord"></i>Join Discord</a>
          </div>
          <div class="partnerships--col card">
            <img src="@/assets/img/mikesmaps.png" class="discord-server-icon">
            <h5>Mikes Maps</h5>
            <a href="https://discord.gg/EYfjrbKvC8" target="_target" class="btn large discord"><i
                class="fab fa-discord"></i>Join Discord</a>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>